export class MessageVoiceService {
  constructor() {}
  textToSpeech(value: string, rate: number): any {
    if ("speechSynthesis" in window) {
      const msg: SpeechSynthesisUtterance = new SpeechSynthesisUtterance();
      msg.lang = "pt-BR";
      msg.text = value;
      msg.rate = rate;
      window.speechSynthesis.speak(msg);
      let r = setInterval(() => {
        if (!window.speechSynthesis.speaking) {
          clearInterval(r);
        } else {
          window.speechSynthesis.pause();
          window.speechSynthesis.resume();
        }
      }, 14000);
      return msg;
    } else {
      console.error("Browsers don't support speech recognition!!");
    }
  }

  stopTextToSpeech(value: string, rate: number): any {
    window.speechSynthesis.cancel();
    return this.textToSpeech(value, rate);
  }
  pauseTextToSpeech(): void {
    window.speechSynthesis.cancel();
  }
}
